var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ul',_vm._l((_vm.collection),function(item){return _c('li',{key:item.caption},[_c('figure',[_c('img',{attrs:{"src":item.imgSrc,"alt":item.caption}}),_c('figcaption',[_vm._v("\n          "+_vm._s(item.caption)+"\n        ")])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }